import { Grid, styled,  TableCell, tableCellClasses,  TableRow } from '@mui/material'
import React from 'react'
import TextLabel from '../Common/CommonTextLabel'
import ButtonContained from '../Common/ButtonContained';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// Custom Table
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontWeight: 400,
        fontSize: 18,
        color: "red",
        // fontFamily: "Wanted Sans", 
        whiteSpace: "nowrap",
        padding: "28px 20px",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 18,
        // fontFamily: "Wanted Sans",
        fontWeight: 400,
        padding: "15px 20px",
        backgroundColor: "#FFFFFF",
        color: "#222222",
        borderBottom: "none",
        textAlign: "left",
        borderBottom: "1px solid #e0e0e0"
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: "#FFFFFF",
    },
    "&:last-child td, &:last-child th": {
        // border: ,
    },
    "& .css-krrlxo-MuiTableCell-root": {
        textAlign: "left",
        fontSize: 18
    },
    // "& .css-1u9qpqh-MuiTableCell-root": {
    //     textAlign: "left",
    //     fontSize: 18
    // },
    // "& .css-1jim5vv-MuiTableCell-root": {
    //     textAlign: "left",
    //     fontSize: 18
    // },
    // "& .css-12sb58d-MuiTableCell-root": {
    //     textAlign: "left",
    //     fontSize: 18
    // },
}));

const CommonTableCell = ({ children, align = 'center', fontWeight = 'normal', ...props }) => {
    return (
        <TableCell align={align} style={{ fontWeight }} {...props}>
            {children}
        </TableCell>
    );
};

const data = [
    { name: "firstname", value: "moon", },
    { name: "lastName", value: "wick", },
    { name: "dob", value: "01/06/1000", },
    { name: "gender", value: "female" },
    { name: "lastName", value: "wick", },
    { name: "dob", value: "01/06/1000", },
    { name: "gender", value: "female" },
    { name: "lastName", value: "wick", },
    { name: "dob", value: "01/06/1000", },
    { name: "gender", value: "female" }
]

const dataPic = [
    {
        title: "Aadhar Card",
        src: "https://static.toiimg.com/thumb/imgsize=123456,msid-108033244,width-600,resizemode-4/108033244.jpg"
    },
    {
        title: "Aadhar Card",
        src: "https://i.pinimg.com/736x/39/e8/76/39e876e7e8ac23fa7a42f86826219f00.jpg"
    },
    {
        title: "Aadhar Card",
        src: "https://adarshc.com/data/user/index/ent/document/pan/banner.jpg"
    }
];

const Payment = ({ _addUpdateMember }) => {

    return (
        <>
            <Grid container xs={12} spacing={2} >
                <Grid item xs={12} display={"flex"} alignItems={"center"} gap={1} mb={3}>
                    <TextLabel fontSize={{ xs: "10px", sm: "15px", md: "20px" }} title={"Payment  :"} />
                    <TextLabel color='#222222' fontSize={{ xs: "10px", md: "16px" }} title={"Please continue with payment."} />
                </Grid>

                <Grid container item xs={12} spacing={2} sx={{ height: "100vh", overflow: "auto" }} >
                    <Grid item xs={12} md={7} lg={6} >
                        <ButtonContained
                            width={"auto"}
                            text={"Save & Payment"}
                            lineHeight={"24.5px"}
                            padding={{ xs: "5px 10px", md: "10px 20px" }}
                            fontSize={{ xs: "12px", md: "14px" }}
                            height={{ xs: "40px", sm: "40px" }}
                            endIcon={<ArrowForwardIcon />}
                            onClick={() => {
                                _addUpdateMember(4)
                            }}
                        />
                    </Grid>
                </Grid>

            </Grid>
        </>
    )
}

export default Payment
